__turbopack_context__.v({
  "backButton": "rRqRhW_backButton",
  "inputWrapper": "rRqRhW_inputWrapper",
  "modal": "rRqRhW_modal",
  "modalBody": "rRqRhW_modalBody",
  "resultSection": "rRqRhW_resultSection",
  "searchInput": "rRqRhW_searchInput",
});
